module.exports = __webpack_public_path__ + "img/haulier-logo.358e335e.svg";